const style = {
  paddingLeftRight100: { paddingLeft: '50px', paddingRight: '50px' },
  colorWhite: { color: 'white' },
  marginTop1em: { marginTop: '1em' },
  paddingSegmentGuest: { paddingBottom: '2em' },
  colorRed: { color: 'red' },
};

export default style;
